import React, { FC } from 'react';
import { Direction } from 'react-range';
import { Colors } from '@inplayer-org/inplayer-ui';
import styled from 'styled-components';

// components
import Slider from 'components/Slider';

// Additional components
import { BlueTypography } from 'components/SharedStyledElements';

const SliderContainer = styled.div<{ direction: 'row' | 'column'; margin: string }>`
  padding: 0.5rem 0.5rem;
  height: 70%;
  width: 70%;
  margin: ${({ margin }) => margin};
  display: flex;
  flex-direction: ${({ direction }) => direction};
  position: relative;
`;

const StyledTypography = styled(BlueTypography)<{ rotate?: boolean }>`
  align-self: center;
  transform: ${({ rotate }) => rotate && 'rotate(-90deg)'};
`;

type Props = {
  heightPercent: number;
  widthPercent: number;
  setHeightPercent: (value: number) => void;
  setWidthPercent: (value: number) => void;
};

const PreviewSlider: FC<Props> = ({ heightPercent, widthPercent, setHeightPercent, setWidthPercent }) => {
  const handleSliderMove = (type: Direction) => (value: Array<number>) => {
    if (type === Direction.Down) {
      setHeightPercent(value[0]);
    } else {
      setWidthPercent(value[0]);
    }
  };

  return (
    <>
      <div />
      <SliderContainer margin="0 auto" direction="column">
        <StyledTypography variant="h5">Width</StyledTypography>
        <Slider
          values={[widthPercent]}
          step={1}
          min={31}
          max={100}
          setValues={handleSliderMove(Direction.Right)}
          sliderColors={[Colors.skyBlue, Colors.darkGray]}
          direction={Direction.Right}
        />
      </SliderContainer>
      <SliderContainer margin="auto 0" direction="row">
        <StyledTypography rotate variant="h5">
          Height
        </StyledTypography>
        <Slider
          values={[heightPercent]}
          step={1}
          min={45}
          max={100}
          setValues={handleSliderMove(Direction.Down)}
          sliderColors={[Colors.skyBlue, Colors.darkGray]}
          direction={Direction.Down}
        />
      </SliderContainer>
    </>
  );
};

export default PreviewSlider;
